export const fetchUpcomingCourses = async (key /* optional combo key */) => {
  const url = key ? `/api/courses/upcoming?key=${encodeURIComponent(key)}` : `/api/courses/upcoming`;
  const res = await fetch(url, { credentials: "include" });
  if (!res.ok) throw new Error("Failed to load courses");
  const data = await res.json();
  // backend already filters sold=false; keep a defensive filter anyway
  return (Array.isArray(data) ? data : []).filter((c) => c && c.sold === false);
};
